module.exports = __webpack_public_path__ + "static/media/camion_a_abastecer.c0b2fdd5.svg";